import React from 'react';
import { Logger } from '@saviynt/common';


class MfeErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    Logger.error('MFE Error Boundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '8px', 
          color: '#d32f2f', 
          fontSize: '12px',
          textAlign: 'center'
        }}>
          MFE component failed to load
        </div>
      );
    }

    return this.props.children;
  }
}

export default MfeErrorBoundary;